import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import CourtService from '../../entities/booking/courtService';

interface CourtServiceState extends ListState<CourtService>{
    editCourtService:CourtService
}
class CourtServiceMutations extends ListMutations<CourtService>{

}
class CourtServiceModule extends ListModule<CourtServiceState,any,CourtService>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<CourtService>(),
        loading:false,
        editCourtService:new CourtService()
    }
    actions={
        async getAll(context:ActionContext<CourtServiceState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/CourtService/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<CourtService>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CourtServiceState,any>,payload:any){
            await Ajax.post('/api/services/app/CourtService/Create',payload.data);
        },
        async update(context:ActionContext<CourtServiceState,any>,payload:any){
            await Ajax.put('/api/services/app/CourtService/Update',payload.data);
        },
        async delete(context:ActionContext<CourtServiceState,any>,payload:any){
            await Ajax.delete('/api/services/app/CourtService/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CourtServiceState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/CourtService/Get?Id='+payload.id);
            return reponse.data.result as CourtService;
        }
    };
    mutations={
        setCurrentPage(state:CourtServiceState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CourtServiceState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CourtServiceState,courtService:CourtService){
            state.editCourtService=courtService;
        }
    }
}
const courtServiceModule=new CourtServiceModule();
export default courtServiceModule;